var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEmptyAvatar = function SvgEmptyAvatar(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#E6E9ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 20.5c0-2.383 1.953-4.375 4.375-4.375 2.383 0 4.375 1.992 4.375 4.375 0 2.422-1.992 4.375-4.375 4.375a4.368 4.368 0 0 1-4.375-4.375ZM20 17.375a3.11 3.11 0 0 0-3.125 3.125c0 1.758 1.367 3.125 3.125 3.125a3.11 3.11 0 0 0 3.125-3.125A3.134 3.134 0 0 0 20 17.375Zm4.14-5.586L24.57 13h2.93c1.367 0 2.5 1.133 2.5 2.5v10c0 1.406-1.133 2.5-2.5 2.5h-15a2.468 2.468 0 0 1-2.5-2.5v-10c0-1.367 1.094-2.5 2.5-2.5h2.89l.43-1.21a1.853 1.853 0 0 1 1.758-1.29h4.805c.82 0 1.523.547 1.758 1.29ZM12.5 14.25c-.703 0-1.25.586-1.25 1.25v10c0 .703.547 1.25 1.25 1.25h15c.664 0 1.25-.547 1.25-1.25v-10c0-.664-.586-1.25-1.25-1.25h-3.828l-.703-2.07a.635.635 0 0 0-.586-.43h-4.805a.635.635 0 0 0-.586.43l-.703 2.07H12.5Z",
    fill: "#C9CED4"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEmptyAvatar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/emptyAvatar.svg";